<template>
    <div></div>
</template>

<script>
export default {
    name: "Result",
    mounted() {
        if (window.parent && window.parent !== window) {
            window.parent.postMessage('3DS-authentication-complete', '*');
        }
        if (window.top && window.top !== window && window.top !== window.parent) {
            window.top.postMessage('3DS-authentication-complete', '*');
        }
    }
}
</script>